<template lang="pug">
.k-field-wrapper.relative
  slot(name="label")
    div(
      v-if="label && topLabel"
      :class="{ 'pb-2': !labelLarge, 'pb-5': labelLarge }"
    ).align-center.d-sm-flex
      label(:class="labelClasses").d-inline-block.mr-5 {{ label }}
      k-field-hint(v-if="inlineHint" inline :quite="quiteHint") {{ hintI18n }}
  .k-field-wrapper__field(ref="inputWrapper")
    template(v-if="sideHint")
      v-row
        v-col(sm="6" cols="12" order-sm="1")
          k-field-hint(side :quite="quiteHint") {{ hintI18n }}
        v-col(sm="6" cols="12" order-sm="0")
          slot
    template(v-else)
      k-field-hint(v-if="topHint" top  :quite="quiteHint") {{ hintI18n }}
      slot
      k-field-hint(v-if="bottomHint" bottom :quite="quiteHint") {{ hintI18n }}
</template>

<script>
import { IsField } from '@/mixins'

export default {
  mixins: [ IsField ],
}
</script>
